import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IKnmUavType } from '../interfaces/IKnmUavType';

export async function fetchKnmUavTypes(): Promise<IKnmUavType[]> {
  return apiGet<IKnmUavType[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/erknm/drone-types`);
}
